import { render, staticRenderFns } from "./BestPractice.vue?vue&type=template&id=62c84bad&scoped=true"
import script from "./BestPractice.vue?vue&type=script&lang=js"
export * from "./BestPractice.vue?vue&type=script&lang=js"
import style0 from "./BestPractice.vue?vue&type=style&index=0&id=62c84bad&prod&lang=scss&scoped=true"
import style1 from "./BestPractice.vue?vue&type=style&index=1&id=62c84bad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c84bad",
  null
  
)

export default component.exports